import { connect } from 'react-redux';
import { clearSelectedInfrastructureTypesAction, searchMapInfrastructureAction, setNoPanoramaAction, setPanoramaActiveAction, setRulerActiveAction, toggleSelectedInfrastructureTypeAction } from '../actions/map';
import { setHouseIdAction, setHoveredHouseIdAction, setHoveredSectionIdAction, setMVKPhaseAction, setSectionIdAction } from '../actions/mvk_state';
import { MVKMap } from '../components/map';
function mapStateToProps(state) {
  var _state$MVKState = state.MVKState,
    phase = _state$MVKState.phase,
    map = _state$MVKState.map,
    house = _state$MVKState.house,
    section = _state$MVKState.section,
    isOfferCard = _state$MVKState.isOfferCard;
  var infrastructureList = map.infrastructureList,
    selectedInfrastructureTypes = map.selectedInfrastructureTypes;
  return {
    currentMVKPhase: phase,
    hoveredHouseId: house.hoveredId,
    hoveredSectionId: section.hoveredId,
    infrastructureList: infrastructureList,
    isNoPanorama: map.isNoPanorama,
    isPanoramaActive: map.isPanoramaActive,
    isRulerActive: map.isRulerActive,
    MVKData: state.MVKData,
    selectedInfrastructureTypes: selectedInfrastructureTypes,
    isOfferCard: isOfferCard,
    withInfrastructure: state.withInfrastructure,
    mapApiKey: state.mapApiKey
  };
}
function mapDispatchToProps(dispatch) {
  return {
    clearSelectedInfrastructureTypes: function clearSelectedInfrastructureTypes() {
      return dispatch(clearSelectedInfrastructureTypesAction());
    },
    searchInfrastructures: function searchInfrastructures(bbox) {
      return dispatch(searchMapInfrastructureAction(bbox));
    },
    setHouseId: function setHouseId(houseId) {
      return dispatch(setHouseIdAction(houseId));
    },
    setHoveredHouseId: function setHoveredHouseId(houseId) {
      return dispatch(setHoveredHouseIdAction(houseId));
    },
    setHoveredSectionId: function setHoveredSectionId(sectionId, houseId) {
      dispatch(setHoveredSectionIdAction(sectionId, houseId));
    },
    setMVKPhase: function setMVKPhase(phase) {
      return dispatch(setMVKPhaseAction(phase));
    },
    setNoPanorama: function setNoPanorama(state) {
      return dispatch(setNoPanoramaAction(state));
    },
    setPanoramaActive: function setPanoramaActive(isActive) {
      return dispatch(setPanoramaActiveAction(isActive));
    },
    setRulerActive: function setRulerActive(isActive) {
      return dispatch(setRulerActiveAction(isActive));
    },
    setSectionId: function setSectionId(sectionId) {
      return dispatch(setSectionIdAction(sectionId));
    },
    toggleSelectedInfrastructureType: function toggleSelectedInfrastructureType(type) {
      dispatch(toggleSelectedInfrastructureTypeAction(type));
    }
  };
}
export var MVKMapContainer = connect(mapStateToProps, mapDispatchToProps)(MVKMap);